module.exports = __webpack_public_path__ + "static/media/tumb.1d8e3e77.svg";